interface ControllerShape<Opts, HTMLElm> {
    create(options: Opts): Promise<HTMLElm>;
    dismiss<T = unknown>(data?: T, role?: string, id?: string): Promise<boolean>;
    getTop(): Promise<HTMLElm | undefined>;
}

export class OverlayBaseController<Opts, Overlay> implements ControllerShape<Opts, Overlay> {
    public constructor(protected ctrl: ControllerShape<Opts, Overlay>) {}

    /**
     * Creates a new overlay
     */
    public create(opts: any) {
        return this.ctrl.create(opts || {});
    }

    /**
     * When `id` is not provided, it dismisses the top overlay.
     */
    public dismiss<T = unknown>(data?: T, role?: string, id?: string) {
        return this.ctrl.dismiss<T>(data, role, id);
    }

    /**
     * Returns the top overlay.
     */
    public getTop() {
        return this.ctrl.getTop();
    }
}
